// src/pages/NuevoProyecto.js
import React, { useState } from 'react';
import { TIPOS_PROYECTO, RESPONSABLES, ESTADOS_PROYECTO } from '../data/proyectos';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export default function NuevoProyecto({ setActivePage }) {
  const [paso, setPaso] = useState(1);
  const [form, setForm] = useState({
    nombre: '', cliente: '', tipo: '', ubicacion: '', descripcion: '',
    responsable: '', estado: 'Propuesta', fecha_inicio: '',
    presupuesto: '', contacto_email: '', contacto_telefono: '',
    parametros: ''
  });
  const [guardado, setGuardado] = useState(false);

  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));
  const tipoSel = TIPOS_PROYECTO.find(t => t.id === form.tipo);

  const guardar = async () => {
    try {
      await addDoc(collection(db, 'proyectos'), {
        ...form,
        avance: 0,
        costo_ejecutado: 0,
        costo_presupuesto: Number(form.presupuesto) || 0,
        creado: serverTimestamp(),
      });
      setGuardado(true);
      setTimeout(() => setActivePage('tracker'), 2000);
    } catch (e) {
      console.error('Error guardando:', e);
      alert('Error al guardar. Revisa la consola.');
    }
  };

  if (guardado) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>✅</div>
        <h2 style={{ color: '#1A2E44', marginBottom: 8 }}>Proyecto creado</h2>
        <p style={{ color: '#6B7A89' }}>Redirigiendo al Tracker...</p>
      </div>
    </div>
  );

  return (
    <div style={{ maxWidth: 760, margin: '0 auto' }}>
      <div className="page-header">
        <div>
          <h1 className="page-title">Nuevo Proyecto</h1>
          <p className="page-subtitle">Paso {paso} de 3</p>
        </div>
        <button className="btn btn-ghost" onClick={() => setActivePage('tracker')}>✕ Cancelar</button>
      </div>

      <div style={{ display: 'flex', gap: 0, marginBottom: 28, background: 'white', borderRadius: 12, padding: '16px 20px', border: '1px solid #E8ECF0' }}>
        {['Tipo de Proyecto', 'Información General', 'Parámetros Técnicos'].map((step, i) => (
          <div key={i} style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }} onClick={() => i < paso && setPaso(i+1)}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', background: paso === i+1 ? '#E8863A' : paso > i+1 ? '#22C55E' : '#E8ECF0', color: paso >= i+1 ? 'white' : '#A8B5C2', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, fontSize: 12, flexShrink: 0 }}>
              {paso > i+1 ? '✓' : i+1}
            </div>
            <span style={{ fontSize: 13, color: paso === i+1 ? '#E8863A' : paso > i+1 ? '#1A2E44' : '#A8B5C2', fontWeight: paso === i+1 ? 500 : 400 }}>{step}</span>
            {i < 2 && <div style={{ flex: 1, height: 1, background: '#E8ECF0', marginLeft: 8 }}></div>}
          </div>
        ))}
      </div>

      <div className="card">
        {paso === 1 && (
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 600, color: '#1A2E44', marginBottom: 6 }}>¿Qué tipo de proyecto es?</h3>
            <p style={{ color: '#6B7A89', fontSize: 13, marginBottom: 20 }}>Selecciona el tipo. Esto determina las fases, checklists y plantillas de memoria técnica.</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
              {TIPOS_PROYECTO.map(tipo => (
                <div key={tipo.id} className={`tipo-card ${form.tipo === tipo.id ? 'selected' : ''}`} onClick={() => set('tipo', tipo.id)}>
                  <div className="tipo-icon">{tipo.icono}</div>
                  <div className="tipo-nombre">{tipo.nombre}</div>
                  <div className="tipo-duracion">⏱ {tipo.duracion}</div>
                  <div style={{ fontSize: 11, color: '#A8B5C2', marginTop: 4 }}>{tipo.software.split(' · ')[0]}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {paso === 2 && (
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 600, color: '#1A2E44', marginBottom: 20 }}>Información general del proyecto</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                <label className="form-label">Nombre del proyecto <span>*</span></label>
                <input className="form-input" placeholder="Ej: Noral Apartments — Instalaciones BIM MEP" value={form.nombre} onChange={e => set('nombre', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Cliente <span>*</span></label>
                <input className="form-input" placeholder="Nombre del cliente o empresa" value={form.cliente} onChange={e => set('cliente', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Ubicación del proyecto</label>
                <input className="form-input" placeholder="Ej: Quito Norte" value={form.ubicacion} onChange={e => set('ubicacion', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Email de contacto del cliente</label>
                <input className="form-input" type="email" placeholder="cliente@empresa.com" value={form.contacto_email} onChange={e => set('contacto_email', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Teléfono de contacto</label>
                <input className="form-input" placeholder="+593 99 000 0000" value={form.contacto_telefono} onChange={e => set('contacto_telefono', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Responsable ARCSEG <span>*</span></label>
                <select className="form-select" value={form.responsable} onChange={e => set('responsable', e.target.value)}>
                  <option value="">Seleccionar...</option>
                  {RESPONSABLES.map(r => <option key={r} value={r}>{r}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Estado inicial</label>
                <select className="form-select" value={form.estado} onChange={e => set('estado', e.target.value)}>
                  {ESTADOS_PROYECTO.map(e => <option key={e} value={e}>{e}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Fecha de inicio</label>
                <input className="form-input" type="date" value={form.fecha_inicio} onChange={e => set('fecha_inicio', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Presupuesto referencial (USD)</label>
                <input className="form-input" type="number" placeholder="0.00" value={form.presupuesto} onChange={e => set('presupuesto', e.target.value)} />
              </div>
              <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                <label className="form-label">Descripción del proyecto</label>
                <textarea className="form-textarea" rows="3" placeholder="Descripción breve del alcance..." value={form.descripcion} onChange={e => set('descripcion', e.target.value)} />
              </div>
            </div>
          </div>
        )}

        {paso === 3 && (
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 600, color: '#1A2E44', marginBottom: 6 }}>Parámetros técnicos iniciales</h3>
            <p style={{ color: '#6B7A89', fontSize: 13, marginBottom: 20 }}>Esta información alimentará al Cerebro IA para generar memorias y checklists personalizados.</p>
            {tipoSel && (
              <div style={{ background: '#F4F6F8', borderRadius: 8, padding: '12px 16px', marginBottom: 20, fontSize: 13 }}>
                <strong style={{ color: '#1A2E44' }}>{tipoSel.icono} {tipoSel.nombre}</strong><br/>
                <span style={{ color: '#6B7A89' }}>Entregable clave: {tipoSel.entregable}</span>
              </div>
            )}
            <div className="form-group">
              <label className="form-label">Parámetros técnicos del proyecto</label>
              <textarea className="form-textarea" rows="6" placeholder="Ingresa los parámetros técnicos conocidos..." value={form.parametros} onChange={e => set('parametros', e.target.value)} />
            </div>
            <div style={{ background: '#FFF7F0', border: '1px solid #FBBF24', borderRadius: 8, padding: '12px 16px', fontSize: 13, color: '#92400E' }}>
              💡 Entre más parámetros ingreses, más precisa será la memoria técnica del Cerebro IA.
            </div>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 28, paddingTop: 20, borderTop: '1px solid #E8ECF0' }}>
          <button className="btn btn-ghost" onClick={() => paso > 1 ? setPaso(paso - 1) : setActivePage('tracker')}>
            {paso === 1 ? '← Cancelar' : '← Anterior'}
          </button>
          {paso < 3 ? (
            <button className="btn btn-primary" onClick={() => setPaso(paso + 1)} disabled={paso === 1 && !form.tipo} style={{ opacity: (paso === 1 && !form.tipo) ? 0.5 : 1 }}>
              Siguiente →
            </button>
          ) : (
            <button className="btn btn-primary" onClick={guardar} disabled={!form.nombre || !form.cliente} style={{ opacity: (!form.nombre || !form.cliente) ? 0.5 : 1 }}>
              ✓ Crear Proyecto
            </button>
          )}
        </div>
      </div>
    </div>
  );
}